import { BaseModel } from "app/models/base";
import { MinUserObj } from "app/models/document";

export class Notification extends BaseModel{
    account?: any;
    createdBy: MinUserObj;
    updatedBy?: any;
    title: string;
    description: string;
    alreadyViewed: boolean;
    type: string;
    asset: minAsset=new minAsset();
}

export class minAsset{
    id: string;
    name: string;
    description?: any;
    status?: any;
    createdDate: string;
    updatedDate?: any;
    size: number;
    fileType: string;
    type: string;
    contentType?: any;
    searchTags?: any;
    extension?: any;
}
